import React, { useEffect, useState } from "react";
import TableAction from "../TableAction";
import { Button, Table } from "antd";
import { useGetBranchesList } from "../../api/organization";
import { useNavigate } from "react-router-dom";
import WithAuth from "../../hoc/WithAuth";
import CreateBranchModal from "../modals/CreateBranchModal";

function BranchesTable() {
  const [open, setOpen] = useState(false);
  const [tableData, setTableData] = useState<any[]>([]);
  const [searchText, setSearchText] = useState("");
  const { data: branches, isLoading } = useGetBranchesList();
  const navigate = useNavigate();

  const handleCreate = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const columns = [
    {
      dataIndex: "name",
      title: "Branch name",
    },
    {
      dataIndex: "email",
      title: "Email",
    },
    {
      dataIndex: "phoneNumber",
      title: "Phone number",
    },
  ];

  useEffect(() => {
    if (searchText) {
      const _data = branches?.data?.data.filter(
        (item: any) =>
          item.name?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.email?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.phoneNumber?.toLowerCase().includes(searchText.toLowerCase()),
      );
      setTableData(_data);
    } else {
      if (branches && branches.data && branches.data.data) {
        setTableData(branches.data.data);
      }
    }
  }, [branches, searchText]);

  return (
    <>
      <CreateBranchModal open={open} hideModal={hideModal} selectedId={""} />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          height: 80,
          backgroundColor: "#EEF3F8",
          borderRadius: 8.4,
          marginBottom: 12,
        }}
      >
        <TableAction setSearchText={setSearchText} onCreateNew={handleCreate} />
      </div>
      <Table
        columns={columns}
        dataSource={tableData}
        style={{
          cursor: "pointer",
          position: "relative",
          zIndex: 100,
          overflowY: "hidden",
        }}
        scroll={{ y: 600 }}
        onRow={(record, index) => {
          return {
            onClick: (event) => {
              navigate(`/branches/${record.id}`);
            },
          };
        }}
      />
    </>
  );
}

export default WithAuth(BranchesTable);
